import { ModuleWithProviders, NgModule } from '@angular/core';

/**
 * No-op replacement for `@shared/commercial-ui/config`'s `CommercialUiConfigModule`.
 * The commercial config module registered routing/permission contributors for the
 * commercial-only widgets; the free in-repo widgets need none, so this is empty.
 */
@NgModule()
export class CommercialUiConfigModule {
  static forRoot(): ModuleWithProviders<CommercialUiConfigModule> {
    return { ngModule: CommercialUiConfigModule, providers: [] };
  }
}
